import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@insurancemenu/imenu-components-lib';
import { ArrowBack } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRFQProposalPageType } from 'global/hooks/useRFQProposalPageType';
import { createStyles } from './styles';

const RFQProposalPageHeader: React.FC = () => {
  const pageType = useRFQProposalPageType();
  const history = useHistory();
  const classes = createStyles();

  const onBackRedirect = (): void => {
    history.goBack();
  };

  const HEADER_LAYOUT = {
    RATE: (
      <>
        <h1 className={classes.title}>Underwrite/Rate RFQ Proposal</h1>
        <div className={classes.caption}>
          Select &quot;Rate/Add Configuration&quot; to enter rates and underwriting conditions for each product template
          in the proposal. Add as many rated version as you want for each product template
        </div>
      </>
    ),
    FILE_UPLOAD: (
      <>
        <h1 className={classes.title}>Add Collateral</h1>
        <div className={classes.caption}>For each plan upload any additional collateral. This is an optional step</div>
      </>
    ),
    RELEASE: (
      <>
        <h1 className={classes.title}>Release RFQ for Review</h1>
        <div className={classes.caption}>Release this response for client review</div>
      </>
    ),
    CREATE_PORTFOLIO: (
      <>
        <h1 className={classes.title}>View RFQ Cart</h1>
        <div className={classes.caption}>Review product selection and create multi-product portfolios as needed</div>
      </>
    ),
    // OVERRIDE_RATES type is not used in RFQ proposal flow
    OVERRIDE_RATES: null,
    GENERAL: <h1 className={classes.title}>Proposal</h1>,
  };

  return (
    <header className={classes.header}>
      <Button
        type="text"
        size="medium"
        onClick={onBackRedirect}
        leftIconProp={<ArrowBack />}
        className={classes.backButton}
      >
        Back
      </Button>
      {HEADER_LAYOUT[pageType]}
    </header>
  );
};

export default RFQProposalPageHeader;
